<div class="flex gap-2 items-center">
  <input
    class="max-w-[64px]"
    panInput
    type="number"
    placeholder="# reviews"
    min="0"
    max="10"
    [disabled]="params.disableActions()"
    [(ngModel)]="cellValue"
    (ngModelChange)="updateReviews($event)"
  />
  <button
    panButton
    icon="speaker_notes"
    fill="clear"
    form="square"
    ariaLabel="Review notes"
    [color]="hasNotes() ? 'primary' : 'default'"
    (click)="showNotes.set(true)"
    data-testid="review-notes-button"
  ></button>
</div>

<app-review-notes-modal
  [locationId]="+params.data.id"
  [locationName]="params.data.name"
  [(isVisible)]="showNotes"
  (saved)="onNotesSaved($event)"
></app-review-notes-modal>
